import { isType, Action } from "typescript-fsa";
import update from "immutability-helper";
import moment from "moment";
import log from "loglevel";
import { Map } from "immutable";

import { isFailedResponseUnauthenticatedNotLogin } from "@api/actions";
import { logout } from "@auth/actions";
import { makeMapLoadedModel, makeMergeEntities, makeHandleShowFailure } from "@orm/models";
import { playlistTrendsGetSuccess } from "@sales/actions";
import * as actions from "../actions";
import {
    Playlist,
    PlaylistSnapshot,
    Track,
    PlaylistSnapshotTrack,
    PlaylistTrack,
    VendorInternalState as State,
    VendorNormalisedEntities,
    PlaylistFilters,
} from "../models";

const getInitialState = () => ({
    entities: {
        playlists: Map<number, Playlist>(),
        playlistSnapshots: Map<number, PlaylistSnapshot>(),
        vendorTracks: Map<number, Track>(),
        playlistSnapshotTracks: Map<string, PlaylistSnapshotTrack>(),
        playlistTracks: Map<string, PlaylistTrack>(),
    },
    playlistFilters: {
        id: null,
        from: moment().subtract(1, "month").startOf("day"),
        to: moment().startOf("day"),
    },
    playlistTracksList: [],
} as State);

const mapLoadedPlaylist = makeMapLoadedModel<Playlist, number>("playlist", Playlist);
const mapLoadedTrack = makeMapLoadedModel<Track, number>("vendor-track", Track);
const mapLoadedPlaylistTrack = makeMapLoadedModel<Track, number>("vendor-playlist-track", PlaylistTrack);
const mergeEntities = makeMergeEntities<State, VendorNormalisedEntities>(
    ["playlists", "playlistSnapshots", "vendorTracks", "playlistSnapshotTracks", "playlistTracks"],
    { playlists: mapLoadedPlaylist, vendorTracks: mapLoadedTrack, playlistTracks: mapLoadedPlaylistTrack },
);
const playlistsShowFailure = makeHandleShowFailure<State, Playlist, VendorNormalisedEntities>(
    Playlist,
    "playlists",
);

const reduce = (state: State = getInitialState(), action: Action<any>): State => {
    // State should never be null...
    if (state === null) {
        log.warn("vendor state setting to null, resetting to initialState.");
        state = {} as State;
        state = update(state, { $set: getInitialState() });
    }

    if (isType(action, actions.setPlaylistFilters)) {
        return setPlaylistFilters(state, action.payload);
    }
    else if (isType(action, actions.playlistsIndexSuccess)) {
        // Successful playlistsIndex
        return mergeEntities(state, action.payload.entities);
    }
    else if (isType(action, actions.playlistsIndexFailure)) {
        // Failed playlistsIndex
    }
    else if (isType(action, actions.playlistsShowSuccess)) {
        // Successful playlistsShow
        return mergeEntities(state, action.payload.entities, "playlist");
    }
    else if (isType(action, playlistTrendsGetSuccess)) {
        // Successful playlistTrendsGet
        return mergeEntities(state, action.payload[1].entities);
    }
    else if (isType(action, actions.playlistsShowFailure)) {
        // Failed playlistsShow
        return playlistsShowFailure(state, action.payload);
    }
    else if (isType(action, actions.tracksIndexSuccess)) {
        // Successful tracksIndex
        return tracksIndexSuccess(state, action.payload);
    }
    else if (isType(action, logout) || isFailedResponseUnauthenticatedNotLogin(action)) {
        // Clear the state on logout.
        return update(state, { $set: getInitialState() });
    }
    // Otherwise we do nothing
    return state;
};

const setPlaylistFilters = (state: State, filters: PlaylistFilters) => {
    return update(state, {
        playlistFilters: { $set: filters },
    });
};

const tracksIndexSuccess = (state: State, { result, entities }: actions.VendorResultString) => {
    const newState = update(state, {
        playlistTracksList: { $set: result },
    });

    return mergeEntities(newState, entities, "vendor-playlist-track");
};

export { reduce as vendor, getInitialState };
